import React from 'react';
import {
  DefaultNotification,
  IDefaultNotificationProps,
} from '../../DefaultNotification';

export interface IFileNotificationProps extends IDefaultNotificationProps {
  stats: 'success' | 'failure';
  error: string | null;
  file_name: string;
  valid_lines: string | null;
  error_lines: string | null;
}

function FileNotification({
  file_name,
  stats,
  error,
  valid_lines,
  error_lines,
  ...rest
}: IFileNotificationProps) {
  const success = 'success';
  return (
    <DefaultNotification {...rest}>
      <small className="mt-2 font-semibold text-[rgba(59,58,52,0.9)]">
        Arquivo: {file_name}
      </small>
      {stats === success ? (
        <div className="flex justify-between md:flex-row flex-col">
          {valid_lines && (
            <small className="mt-[0.2rem] font-semibold text-[rgba(59,58,52,0.9)] text-[var(--green)]">
              Linhas válidas: {valid_lines}
            </small>
          )}
          {error_lines && (
            <small className="mt-[0.2rem] font-semibold text-[rgba(59,58,52,0.9)] text-[var(--red)]">
              Linhas inválidas: {error_lines}
            </small>
          )}
        </div>
      ) : (
        <p>
          {error && (
            <small className="mt-[0.2rem] font-semibold text-[rgba(59,58,52,0.9)] text-[var(--red)]">
              {error}
            </small>
          )}
        </p>
      )}
    </DefaultNotification>
  );
}

export default FileNotification;
